import { render, staticRenderFns } from "./PanelComment.vue?vue&type=template&id=79891ac6&scoped=true"
import script from "./PanelComment.vue?vue&type=script&lang=js"
export * from "./PanelComment.vue?vue&type=script&lang=js"
import style0 from "./PanelComment.vue?vue&type=style&index=0&id=79891ac6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79891ac6",
  null
  
)

export default component.exports